module.exports = __webpack_public_path__ + "static/raiffeisen-8c0faddae557a9a0669a32da41aef1c7.png";